import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useCampaigns } from "api/campaigns";
import { getBackendErrors } from "api/errors";
import { TextInput } from "components/FormControls/TextInput";
import { OLModal } from "components/Tooltips/OLModal";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { Form, Formik } from "formik";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useParams } from "react-router-dom";
import { backendErrors } from "utilities/backendErrors";
import * as Yup from "yup";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    input: {
      width: "100%",
      marginBottom: theme.spacing(12),
    },
  }),
);

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const GenerateCodesModal = ({ isOpen, onClose }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const { generateRedemptionCodes } = useCampaigns();
  const { id: campaignID } = useParams<{ id: string }>();

  return (
    <OLModal
      onClose={onClose}
      open={isOpen}
      header={message({ id: "generateRedemptionCodes" })}
    >
      <Formik
        initialValues={{
          numberOfCodes: undefined,
        }}
        validationSchema={Yup.object({
          numberOfCodes: Yup.number().required(message({ id: "required" })),
        })}
        onSubmit={async ({ numberOfCodes }, { setErrors }) => {
          try {
            await generateRedemptionCodes(numberOfCodes, campaignID);
            onClose();
          } catch (exception) {
            const errors = backendErrors(getBackendErrors(exception));

            if (errors) {
              setErrors(errors);
            }
          }
        }}
      >
        {({ handleSubmit, isSubmitting }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <TextInput
                name="numberOfCodes"
                type="number"
                label={message({ id: "numberOfGeneratedRedemptionCodes" })}
                className={classes.input}
                required
                data-test-id="redemption-code-generate-codes-number-input"
              />

              <OLButton
                disabled={isSubmitting}
                fullWidth
                type="submit"
                variant="contained"
                data-test-id="redemption-code-generate-codes-submit-button"
              >
                {message({ id: "generateRedemptionCodes" })}
              </OLButton>
            </Form>
          );
        }}
      </Formik>
    </OLModal>
  );
};

export default GenerateCodesModal;
